import { createComponentExtension } from '@backstage/core-plugin-api';
import { catalogPlugin } from '@backstage/plugin-catalog';

export const EntityAboutCard: () => React.JSX.Element = catalogPlugin.provide(
  createComponentExtension({
    name: 'EntityAboutCard',
    component: {
      lazy: () => import('./AboutCard').then(m => m.AboutCard),
    },
  }),
);
